import { createFileRoute } from "@tanstack/react-router";
import { PackageList } from "@/components/admin/package-list";

export const Route = createFileRoute("/_auth/app/admin/packages")({
  component: PackagesPage,
});

function PackagesPage() {
  return <PackageList />;
}
